<template>
      <div
        class="modal right fade trader-info"
        id="trader-info"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"       
      >
        <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title mr-auto p-2" >Filter Preview</h5> 
                <span v-if="count > 0 && uuidFromNotification === uuid" class="badge badge-primary badge-pill mt-2">{{count}}</span>
              <button type="button" class="close" @click="$emit('close')">
            <span aria-hidden="true">&times;</span>
          </button>

            </div>
            <div class="modal-body table-responsive">
                <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                <table class="table align-items-center table-flush table-hover bidtbl  ">
                    <thead class="thead-light psticky">
                    <tr>
                        <th 
                        class="text-center sort" 
                        v-for="(column, index) in columnHeaders" 
                        v-bind:class="[
                            sortOrder == 'ASC' && sortColumn == column.columnvalue  ? 'sort-asc' : '',
                            sortOrder == 'DESC' && sortColumn == column.columnvalue  ? 'sort-desc' : '',
                            ]"  
                        @click="sort(column.columnvalue)"
                        :key="index">
                            {{column.column.replace(/_/g, ' ')}}
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-if="offers.length == 0 && !loading">
                        <td><p class="nodata">No data available</p>
                        </td>
                    </tr>
                    <tr v-for="offer in offers" :key="offer.id">
                        <td class="text-center" v-for="(column, index) in columnHeaders" :key="index">
                            <span v-if="column.columntype == 'currency'">{{ offer[column.columnvalue] | currency }}</span>
                            <span v-else-if="column.columntype == 'percentage'">
                                <div v-if="column.columnvalue == 'askYtc' || column.columnvalue == 'askYtm' || column.columnvalue == 'askYtw'">
                                <span v-if="typeof offer[column.columnvalue] === 'number'">
                                    <span v-if="offer[column.columnvalue] * 100 > 16">
                                    <span>N/A</span>
                                    </span>
                                    <span v-else>
                                    {{offer[column.columnvalue] | percent(3)}}
                                    </span>
                                </span>
                                <span v-else>{{offer[column.columnvalue]}}</span>
                                </div>
                                <div v-else>
                                <span v-if="typeof offer[column.columnvalue] === 'number'">{{offer[column.columnvalue] | percent(3)}}</span>
                                <span v-else>{{offer[column.columnvalue]}}</span>
                                </div>

                            </span>
                            <span v-else-if="column.columnvalue == 'cusip'">
                                <span>{{offer[column.columnvalue]}}</span> 
                            </span>
                            <span v-else-if="column.columnvalue == 'settlementDate'">
                                <span v-if="offer.settlementDate && !offer.isRegularSettlement" class="text-red">{{offer[column.columnvalue]}}</span>
                                <span v-else>{{offer[column.columnvalue]}}</span>
                            </span>
                            <span v-else-if="column.columnvalue == 'firstSettlementDate'">
                                <span v-if="!offer.settlementDate && !offer.isRegularSettlement " class="text-red">{{offer[column.columnvalue]}}</span>
                                <span v-else>{{offer[column.columnvalue]}}</span>
                            </span>
                            <span v-else-if="Array.isArray(offer[column.columnvalue])">{{offer[column.columnvalue].toString()}}</span>
                            <span v-else-if="column.columnvalue == 'minQty'">{{ offer[column.columnvalue] ? offer[column.columnvalue]  : 'N/A'}}</span>
                            <span v-else>{{ offer[column.columnvalue] }}</span>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <nav aria-label="Page navigation example" v-if="!(offers.length == 0)">
                <ul class="pagination justify-content-center">
                  <li class="page-item" v-bind:class="{ disabled: !prevCursor }">
                    <a class="page-link cursor-pointer" @click="nextOrPrev('prev')">
                      <i class="fa fa-angle-left"></i>
                      <span class="sr-only">Previous</span>
                    </a>
                  </li>
                  <li class="page-item active"><a class="page-link">{{ currentPage }}</a></li>
                  <li class="page-item" v-bind:class="{ disabled: !nextCursor }">
                    <a class="page-link cursor-pointer" @click="nextOrPrev('next')">
                      <i class="fa fa-angle-right"></i>
                      <span class="sr-only">Next</span>
                    </a>
                  </li>
                </ul>
              </nav>
          
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" @click="$emit('close')">Close</button>
            </div>
          </div>
        </div>
      </div>
</template>

<script>
    import authService from "@/authService";
    import config from "@/config";
    export default {
        name: 'customerEmails',
        components :{
            
        },
        props: ['filterData'],
        data() {
            return {
                loading : false,
                offers : [],  
                selectedOffer: null, 
                columnHeaders: [],   
                uuid: null,
                count: 0,
                uuidFromNotification: null,
                cursor: "",
                nextCursor: null,
                prevCursor: null,
                currentPage: 1,
                sortColumn: null,
                sortOrder: null,

            }
        },
        methods: {
                sort(column) {
                    this.sortColumn = column;
                    this.sortOrder = this.sortOrder == 'ASC' ? this.sortOrder = "DESC" : this.sortOrder = 'ASC';
                    this.getPreviewData();
                },
             nextOrPrev(nextOrPrev) {
                if (!this.loading) {
                    this.getPreviewData(nextOrPrev)
                }
            },
            addtoList(offer){
                offer.changeOfferId = this.offerProp.id;
                this.$root.$emit("offerchange",offer);  
                this.$emit('close');
            },  
            getPreviewData(mode){
                this.loading = true;
                const auth = {
                    headers: { 'org-token' : authService.getOrgToken() }
                };
                 if (mode == "next") {
                    this.cursor = this.nextCursor;
                    if (!this.nextCursor) return
                }
                if (mode == "prev") {
                    this.cursor = this.prevCursor;
                    if (!this.prevCursor) return
                }
                if (!mode) {
                    this.cursor = null;
                    this.currentPage = 1
                }
                this.uuid = this.uuidv4();
                delete this.filterData.customers;
                delete this.filterData.userId;
                delete this.filterData.description;
                delete this.filterData.status;
                delete this.filterData.filterType;
                delete this.filterData.shouldEmailNotify;
                delete this.filterData.shouldPushNotify;
                delete this.filterData.enable;

                this.filterData.minMaturityDate = this.filterData.minMaturityDate ? this.moment(this.filterData.minMaturityDate).format("YYYY-MM-DD") : null;               
                this.filterData.maxMaturityDate = this.filterData.maxMaturityDate ? this.moment(this.filterData.maxMaturityDate).format("YYYY-MM-DD") : null;               
                this.filterData.minCallDate = this.filterData.minCallDate ? this.moment(this.filterData.minCallDate).format("YYYY-MM-DD") : null;               
                this.filterData.maxCallDate = this.filterData.maxCallDate ? this.moment(this.filterData.maxCallDate).format("YYYY-MM-DD") : null;   
                
                let data = {
                    "size": 10,
                    "cursor":  this.cursor ? this.cursor : null,
                    "userId": authService.getUser().id,
                    "cognitoSub": authService.getUser().cognitoSub,
                    "uuid": this.uuid,
                    "sortColumn": this.sortColumn,
                    "sortOrder": this.sortOrder,
                    "filter": this.filterData
                };

                this.$http
                .post(
                config.baseUrlAutoBidder +
                    "/offering-feed/list-hits/preview",data,
                    auth
                )
                .then(result => {
                    this.offers = result.data.content;
                    this.nextCursor = result.data.pageInfo.nextCursor;
                    this.prevCursor = result.data.pageInfo.prevCursor;
                    this.loading = false;
                    if (mode == "next") {
                        this.currentPage = this.currentPage + 1;
                    }
                    if (mode == "prev") {
                        this.currentPage = this.currentPage - 1;
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
            },
            getSavedColumnOptions() {
                this.loading = true;
                const auth = {
                    headers: { 'org-token': authService.getOrgToken() }
                };
                this.$http
                    .get(
                    config.baseUrlAutoBidder +
                    "/offering-feed/column-setting?userId=" +
                    authService.getUser().id,
                    auth
                    )
                    .then(result => {
                        this.loading = false;
                        this.columnHeaders = result.data.columnInfos.filter(column => column.availableForPreview);
                        this.getPreviewData();
                    })
            },

        },
        mounted(){
        console.log("filterData in preview", this.filterData);
          //this.getOffers();
          this.getSavedColumnOptions();
          this.$root.$on("offeringfeedpreviewcount", (data) => {
            this.uuidFromNotification = data.count.uuid;
            this.count = data.count.count;
        });
        },
         beforeDestroy() {
            this.$root.$off("offeringfeedpreviewcount");
        },
    };
    </script>